import { IGamesGridState } from './types';
import { TGamesFeedCategoryParsed } from '../types';
import { DEFAULT_FILTERS_STATE } from './constants';

export const categorySelector = (categoryName: string) =>
    (state: IGamesGridState): TGamesFeedCategoryParsed | undefined => {
        return (
            state.gamesFeed?.gamesFeedCategories.find(
                (feedCategory: TGamesFeedCategoryParsed) => feedCategory.name === categoryName
            )
        );
    };

export const isFiltersChanged = (draftState: IGamesGridState, defaultState: typeof DEFAULT_FILTERS_STATE): boolean => {
    return Object.keys(defaultState)
        .some((key) => {
            const draftStateValue = draftState[key as keyof IGamesGridState];
            const defaultStateValue = defaultState[key as keyof typeof DEFAULT_FILTERS_STATE];

            if (typeof draftStateValue === 'object') {
                return Boolean(Object.values(draftStateValue).some((value) => Boolean(value)));
            }

            return draftStateValue !== defaultStateValue;
        });
};

